<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    title=""
    width="400px"
    :close-on-click-modal="false"
    append-to-body
  >
    <label>{{ $t('Partners.companyIsSettlementAgentFollowingPartners') }}</label>
    <label>{{ $t('Partners.disassociateAndSaveModifications') }}</label>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        :locale-text-func="_i18nGridLocalText"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="cList"
        :show-side-bar="false"
        style="width:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <span slot="footer">
      <el-button no="enterHandler" type="primary" @click="enterHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'SettleAgentDialog',
  components: { },
  props: {
    visible: { type: Boolean, defaultValue: false },
    cList: { type: Array, defaultValue: [] },
    func: { type: Function, defaultValue: () => {} },
    uuid: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridApi: null,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Partners.chineseName'),
          field: 'NAME',
          width: 200
        }, {
          headerName: this.$t('SeaExport.ChargeBranchId'),
          field: 'CODE',
          width: 200
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    enterHandler() {
      this.func()
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
